import {Select} from "@cjdev-internal/visual-stack-x/Select";
import {DROPDOWN_PLACEHOLDER} from "../../constants/appConstant";

const CampaignsDropDown = ({id, handleChange, optionsValue, defaultValue, errorData}) => {
    const customStyles = {
        option: (provided, {isSelected, isFocused}) => ({
            ...provided,
            backgroundColor: isSelected ? '#DDDDDD !important' : (isFocused ? '#F6F6F6 !important' : '#FFFFFF')
        }),
        placeholder: defaultStyles => {
            return {
                ...defaultStyles,
                fontSize: '1.3rem !important',
                lineHeight: '1.4rem !important',
                color: '#808080'
            };
        }
    }

    return (<Select
        id={id}
        styles={customStyles}
        defaultValue={defaultValue}
        placeholder={DROPDOWN_PLACEHOLDER}
        options={optionsValue}
        onChange={(event) => (id === "advertiserCompanyId" ? handleChange(id, event) : handleChange(id, event.value))}
        error={errorData && errorData.value ? true : false}
    />);

};
export default CampaignsDropDown;